<template>
  <v-row data-testid="so-row">
    <slot></slot>
  </v-row>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({})
</script>
